import type { CreateCompanyInput } from '@idc-forms/schemas'
import { useSidePanelStore } from '@/shared/store/side-panel.store'
import { useCreateCompanyV2Mutation } from '../hooks/use-company-v2-mutations'
import { CompanyForm } from './company-form'

type CompanyV2CreatePanelProps = {
  onDone?: () => void
}

/**
 * "Nueva empresa" contra la API v2. Reusa el MISMO `CompanyForm` que la rama v1:
 * el contrato de entrada v2 (`name`, `giinNumber`, `default`, `active`) coincide
 * campo a campo con `CreateCompanyInputSchema`, porque `type` y `blocked` son de
 * sistema en las dos versiones y nunca fueron editables.
 */
export function CompanyV2CreatePanel({ onDone }: CompanyV2CreatePanelProps) {
  const closePanel = useSidePanelStore((s) => s.closePanel)
  const createMutation = useCreateCompanyV2Mutation()
  const done = onDone ?? closePanel

  const handleSubmit = (values: CreateCompanyInput) => {
    createMutation.mutate(values, {
      onSuccess: () => {
        done()
      }
    })
  }

  return (
    <CompanyForm
      submitLabel="Crear empresa"
      pending={createMutation.isPending}
      onSubmit={handleSubmit}
      onCancel={done}
    />
  )
}
